import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {NoticeTableComponent} from "../notice-table/notice-table.component";
import {NoticesStateService} from "../notices-state.service";
import {NoticeModalsComponent} from "../notice-modals/notice-modals.component";
import { UserInfoService } from "../../user-info.service";
import { FormControl, FormGroup } from "@angular/forms";
import { NoticeService } from "../../../../swaggerServices";
import { TenantConfigService } from "../../../shared/services/tenant-config.service";
import { ConfigStateService } from "../../config/config-state.service";
import { Subscription } from "rxjs";

declare var $: any;

@Component({
    selector: 'app-notices-workflow',
    templateUrl: './notices-workflow.component.html',
    styleUrls: ['./notices-workflow.component.scss'],
    providers: [NoticesStateService],
    standalone: false
})
export class NoticesWorkflowComponent implements OnInit, OnDestroy {
  @ViewChild(NoticeTableComponent) noticeTableComponent: NoticeTableComponent;
  @ViewChild(NoticeModalsComponent) noticeModalsComponent: NoticeModalsComponent;
  taxpayerAlias: string;
  uiConfig: TenantConfigService;
  subscriptions: Subscription[] = [];

  get selectedNotice() { return this.noticesState.selectedNotice; }
  get noticeMetadata() { return this.noticesState.noticeMetadata; }
  get savingNotice() { return this.noticesState.savingNotice; }
  get savingMetadata() { return this.noticesState.savingMetadata; }

  constructor(public noticesState: NoticesStateService,
              public userInfo: UserInfoService,
              public config: ConfigStateService,
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxpayerAlias = this.uiConfig.config.taxReturnAlias;
      })
    );
  }

  ngOnDestroy() {
    this.noticesState.cleanUp();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  openCreateUpdateNoticeModal() {
    // NOTE(mike): I built this as a subscribable so that this would work if this component used
    // OnPush change detection. I thought we did use it here but turns out we don't!
    this.noticeModalsComponent.openCreateUpdateNoticeModal(this.selectedNotice).subscribe();
  }

  onNoticeCreatedOrEdited() {
    this.noticesState.selectNotice(null);
    this.noticeTableComponent.doSearch();
  }
}
